import { FormControl } from '@angular/forms';
import * as moment from 'moment';
import { downloadFile, downloadStr } from '../../../core/download-string';
// app services
import { AuthService } from '../../../api/auth.service';
import { LangService } from '../../../core/lang.service';
import { IQuestionConfig, IQuestionScoringInfo, IScoringCodes } from '../../../ui-testrunner/models';
import { IItemAuthNote } from '../../element-notes/element-notes.component';
import { ItemParameterType, PARAM_SPECIAL_FLAGS } from '../../framework-dimension-editor/model';
import { ItemMakerService } from '../../item-maker.service';
import { ItemType } from '../../models';
import { getPartitionPropValue, IPanelModulesConfig, IProgressBarConfig, ISectionItems } from '../models/assessment-framework';
import { DimensionCategory, DimensionType, ENextBtnOpt, IAccessibilitySetting, IAssessmentFrameworkDef, IAssessmentFrameworkDetail, IAssessmentFrameworkDimensionDetail, IAssessmentPartition, NEXT_BTN_OPTS, QUESTION_WORDING_OPTS, TestFormConstructionMethod } from '../models/assessment-framework';
import { stripTabs, TAB, NEWLINE } from '../models/constants';
import { QuestionView } from '../models/types';
import { ItemBankCtrl } from './item-bank';
import { ItemFilterCtrl } from './item-filter';
import { PanelCtrl } from './mscat';
import { ItemSetPublishingCtrl } from './publishing';
import { FrameworkQuadrantCtrl } from './quadrants';
import { ItemBankSaveLoadCtrl } from './save-load';
import { TestletCtrl } from './testlets';
import { ItemBankUtilCtrl } from './util';
import { Destroyable } from './destroyable';
import { CLICK_TO_DRAG_DEFAULT } from 'src/app/ui-testrunner/accessibility.service';
import { CUSTOM_PROGRESS_BAR_CONFIG } from '../../widget-framework-settings/editors/progress-bar-editor/constants';
import { checkPropCondVal } from '../../widget-audits/util/content-analysis';
import { AuditQuestionScope, EFilterMethods, IParamFlag, TItemParamFlagMap } from '../../widget-audits/data/audits';
import { parseParamCodeList } from '../../framework-dimension-input/param-whitespace';
import { buildItemScopeContext, DEFAULT_AUDIT_SCOPE, getQuestionsByScopeSync } from '../../widget-audits/util/item-scopes';
import { sortQuadrantsBySectionInPlace } from '../services/quadrant-section';
import { IParamImportPlan, IParamImportCell, PARAM_IMPORT_MAX_RENDERED_ROWS, isParamImportValueChange, countChangedParamImportCells, countUnchangedParamImportCells, getVisibleParamImportCells, buildParamImportChangeSetCsv, normalizeQuestionImportLabel, buildQuestionsByImportLabel, countChangedFlips } from './param-import-plan';

type SimplifiedQuestion = { id: number, label?: string }[];
type RemovedQuestionMap = {[key:string]: string[]};

export class ItemSetFrameworkCtrl implements Destroyable {
  
  selectedNewItemBank = new FormControl();

  accessibilitySettings: {
    [key:string]:IAccessibilitySetting
  } = {
    clickToDragDrop: {
      caption: 'click_to_drag_drop',
      isConfigurable: false,
      defaultVal: CLICK_TO_DRAG_DEFAULT
    }
  }
  asmtFmrk: IAssessmentFrameworkDetail;
  isFrameworkParamImportExport:boolean;
  isScoringScalesExpanded: boolean;
  frameworkParamImportExport = new FormControl();
  isEditRawFramework:boolean;
  rawFrameworkJson = new FormControl();
  paramExpansionMap:Map<IAssessmentFrameworkDimensionDetail, boolean> = new Map();
  isParamImportDryRun = new FormControl(false);
  public isParamDetailExpanded:boolean = false;
  public isAFParamDetailExpanded:boolean = false;
  public isAFParamDetailOrdering:boolean = false;
  public isFrameworkView:boolean;
  jsonImport = new FormControl();
  isImportOpen: boolean;
  isImporting: boolean;
  isImportFlushing: boolean;
  /** Item-by-item progress while Apply runs (null otherwise). */
  importProgress: { done: number, total: number } = null;
  paramImportPlan: IParamImportPlan;
  isParamImportChangedOnly = new FormControl(true);
  /** Bumped whenever the modal opens/closes or a new file is chosen so a stale verification pass stops writing. */
  private paramImportRunId = 0;
  readonly paramImportMaxRenderedRows = PARAM_IMPORT_MAX_RENDERED_ROWS;
  assessmentFrameworks: IAssessmentFrameworkDef[] = [{__id: '1', caption: ''}];
  activeAssessmentFramework = new FormControl();
  activeAsmtFwrkDimensions: Array<IAssessmentFrameworkDimensionDetail[]>; // an array of arrays...
  isEditingFramework: boolean;
  questionFrameworkMap: {d1: string[], d2: string[], count: Map<string, number>};
  selectedQuestionView = QuestionView.QUESTION_BANK;
  /**
   * Assembled panel the Module Map is scoped to. Held here rather than on the map
   * widget because launching a preview tears that widget down and rebuilds it on exit.
   */
  moduleMapPanelId = '';
  /** OSSLT student map is one session at a time: 'A' | 'B'. */
  moduleMapSession: 'A' | 'B' = 'A';
  public testFormConstructionMethod = new FormControl(TestFormConstructionMethod.TLOFT);
  public questionWordingFc = new FormControl(QUESTION_WORDING_OPTS[0]);
  availableItemSets;
  isReadyToAddItemSet;
  allowNewItemsDuringParamImport = new FormControl(false);
  requireItemBankRefresh: boolean;
  importingQuestionLabel: string;
  progressBarDefaults: {slug: string, config: IProgressBarConfig}[] = [{slug: 'lbl_none', config: CUSTOM_PROGRESS_BAR_CONFIG()}];

  paramFlaggedMap:TItemParamFlagMap = new Map()
  /** Session-only Content column subset (codes). Cleared on refresh; not persisted. */
  sessionContentParamCodes: string[] | null = null;
  sessionContentParamInput = '';
  /** Unique param codes collected by PARAM_VALIDATION (and similar) per check. */
  paramCodeCollectorByCheckId = new Map<string, string[]>();
  public util = new ItemBankUtilCtrl();
  
  public saveLoadCtrl: ItemBankSaveLoadCtrl;
  public panelCtrl: PanelCtrl;
  public quadrantCtrl: FrameworkQuadrantCtrl;
  public testletCtrl: TestletCtrl;
  public itemFilterCtrl: ItemFilterCtrl;
  public publishingCtrl: ItemSetPublishingCtrl;

  partitionIdToPreambleFc: {[key:number]: FormControl} = {};
  partitionIdToPostambleFc: {[key:number]: FormControl} = {};

  isParamSaveRequired = false;

  constructor(
    public auth: AuthService,
    public myItems: ItemMakerService,
    public itemBankCtrl: ItemBankCtrl,
    private lang: LangService
  ){
    
  }

  destroy() {
    
  }

  isTestformMsCat() { return this.testFormConstructionMethod.value === TestFormConstructionMethod.MSCAT; }
  isTestformLinear() { return this.testFormConstructionMethod.value === TestFormConstructionMethod.LINEAR; }
  isTestformLOFT() { return this.testFormConstructionMethod.value === TestFormConstructionMethod.TLOFT; }
  isTestFormDirectConstruction = () => this.isTestformLinear() && (this.selectedQuestionView === QuestionView.FORM_CONSTRUCTION);

  expandParam(param:IAssessmentFrameworkDimensionDetail, isExpand=true){
    this.paramExpansionMap.set(param, isExpand);
  }
  isParamExpanded(param:IAssessmentFrameworkDimensionDetail){
    return this.paramExpansionMap.get(param);
  }
  getParamCategNaming(dimLevel: number) {
    if (dimLevel === 0) {
      return 'Dimension';
    }
    return this.lang.tra('ie_parameter');
  }

  getPairableHumanScoringScales() {
    // console.log("pair", this.asmtFmrk.pairableHumanScoringScales)
    return this.asmtFmrk.pairableHumanScoringScales || [];
  }

  addPairableHumanScoringScales() {
    if(!this.asmtFmrk.pairableHumanScoringScales) this.asmtFmrk.pairableHumanScoringScales = [];
    this.asmtFmrk.pairableHumanScoringScales.push([
      { id: 0, name: '', description: '' },
      { id: 0, name: '', description: '' }
    ]);
    // console.log(this.asmtFmrk.pairableHumanScoringScales)
  }

  updatePairableHumanScoringScales(pairIdx: number, scaleIdx: number, scale: IScoringCodes) {
    if(!this.asmtFmrk.pairableHumanScoringScales) return;
    const existingScale = this.asmtFmrk.pairableHumanScoringScales[pairIdx][scaleIdx];
    existingScale.name = scale.short_name
    existingScale.id = scale.id
    if(this.lang.c() === 'fr'){
      existingScale.description =  scale.description_fr;
    } else {
      existingScale.description = scale.description_en;
    }

  }

  // removePairableHumanScoringScaleIds(pairIdx) {
  //   if(!this.asmtFmrk.pairableHumanScoringScaleIds) return;
  //   this.asmtFmrk.pairableHumanScoringScaleIds.splice(pairIdx, 1);
  // }
  
  checkIsAllReady() {
    let isAllReady = true;
    this.itemBankCtrl.getItems().forEach(question => {
      if (!question.isInfoSlide && !question.isReady) {
        isAllReady = false;
      }
    });
    return isAllReady;
  }

  getNumModules = () => ''; // deprecated
  
  previewQuestionFrameworkMapping() {
    console.log('previewQuestionFrameworkMapping 1');
    this.questionFrameworkMap = {
      d1: [],
      d2: [],
      count: new Map()
    };
    let d1Def = this.asmtFmrk.primaryDimensions[0];
    let d2Def = this.asmtFmrk.primaryDimensions[1];
    let d1Tags = d1Def.config.tags;
    let d2Tags = d2Def.config.tags;
    // let d1_pre = this.questionFrameworkMap.d1 = d1Tags.map(tag => tag.code);
    let d2 = this.questionFrameworkMap.d2 = d2Tags.map(tag => tag.code);
    let joiner, joinerCode;
    this.asmtFmrk.secondaryDimensions.forEach(sec => { // grossnes....
      if (sec.code === 'D1b') {
        joinerCode = sec.code;
        joiner = sec.config.tags.map(tag => tag.code);
      }
    });
    
    let d1 = this.questionFrameworkMap.d1 = joiner;
    d1.forEach(tag1 => {
      d2.forEach(tag2 => {
        let key = tag1 + '/' + tag2;
        this.questionFrameworkMap.count.set(key, 0);
      });
    });
    this.itemBankCtrl.getItems().forEach(question => {
      let tag1 = question['meta'][joinerCode];
      let tag2 = question['meta'][d2Def.code];
      if (tag1 && tag2) {
        let key = tag1 + '/' + tag2;
        let count = this.questionFrameworkMap.count.get(key);
        this.questionFrameworkMap.count.set(key, count + 1);
      }
    });
    console.log('previewQuestionFrameworkMapping 2');
  }
  
  getSectionQuestionsLinear = (asmtFmrk:IAssessmentFrameworkDetail, partition: IAssessmentPartition) => {
    const sectionId = partition.id;
    if (!this.asmtFmrk.sectionItems) {
      this.asmtFmrk.sectionItems = {};
    }
    let sectionItems = this.asmtFmrk.sectionItems[sectionId];
    if (!sectionItems) {
      sectionItems = this.asmtFmrk.sectionItems[sectionId] = {
        questions: []
      };
    }
    return sectionItems;
  }

  getSectionQuestionsLinearConfig(partition: IAssessmentPartition){
    const sectionItems = this.getSectionQuestionsLinear(null, partition).questions;
    return sectionItems.map(item => this.itemBankCtrl.getQuestionById(item.id))
  }
  
  removeQuestionFromTestform(questionIdentifier, partition: IAssessmentPartition) {
    if (confirm('Are you sure you want to remove this item? ' + `(${questionIdentifier.label})`)) {
      const sectionQuestions = this.getSectionQuestionsLinear(this.asmtFmrk, partition);
      const i = sectionQuestions.questions.indexOf(questionIdentifier);
      if (i !== -1) {
        sectionQuestions.questions.splice(i , 1);
      }
    }
  }
  /**
   * 
   * @returns A map containing removed questions depending on the type of assesment it'll map to testlets, sections, and/or panels
   */
  getRemovedQuestionInFramework() {
    const removedQuestionsMap: RemovedQuestionMap = {};
    switch (this.testFormConstructionMethod.value as TestFormConstructionMethod) {
      default:
      case TestFormConstructionMethod.LINEAR:
        this.getRemovedQuestionFromLinearForm(removedQuestionsMap);
        break;
      case TestFormConstructionMethod.TLOFT:
        this.getRemovedQuestionFromTestlets(removedQuestionsMap);
        break;
      case TestFormConstructionMethod.MSCAT:
        this.getRemovedQuestionFromMSCATPanel(removedQuestionsMap);
        this.getRemovedQuestionFromTestlets(removedQuestionsMap);
        break;
    }
    return removedQuestionsMap
  }

  /**
   * Function that takes a map and populates with removed question in the current frameworks linear forms
   * @param removedQuestionsMap a map of removed question
   */
  getRemovedQuestionFromLinearForm(removedQuestionsMap: RemovedQuestionMap){
    this.asmtFmrk.partitions.forEach((partition) => {
      const questionInCurrentPartition = this.getSectionQuestionsLinear(this.asmtFmrk, partition).questions;
      const removedInCurrentPartition = this.getRemovedQuestions(questionInCurrentPartition as SimplifiedQuestion);
      if (removedInCurrentPartition.length > 0) {
        removedQuestionsMap[partition.description] = removedInCurrentPartition;
      }
    });
  }

  /**
   * Function that takes a map and populates with removed question in the current frameworks testlets
   * @param removedQuestionsMap a map of removed question
   */
  getRemovedQuestionFromTestlets(removedQuestionsMap: RemovedQuestionMap){
    this.asmtFmrk.testlets.forEach(testlet => {
      const removedInCurrentTestlet = this.getRemovedQuestions(testlet.questions as SimplifiedQuestion);
      if (removedInCurrentTestlet.length > 0) {
        const testletKey = `Testlet ${this.lang.tra('ie_id')} ${testlet.id}`
        removedQuestionsMap[testletKey] = removedInCurrentTestlet;
      }
    });
  }


  getRemovedQuestionFromMSCATPanel(removedQuestionsMap: RemovedQuestionMap) {
    this.asmtFmrk.panels?.forEach(panel => {
      const panelKey = `${this.lang.tra('ie_panel')} ${this.lang.tra('ie_id')} ${panel.id}`;
      let removedQuestionsFormatted = [];
  
      panel.modules.forEach(module => {
        const questions = module.__cached_itemIds.map((id, index) => {
          const question = this.itemBankCtrl.getQuestionById(id);
          return question ? question : { id: id, label: module.itemLabels[index] };
        });        
        const removedInCurrentModule = this.getRemovedQuestions(questions as SimplifiedQuestion);
        if (removedInCurrentModule.length) {
          const removedQuestionInCurrentModule = `Module ${module.moduleId}: ${removedInCurrentModule.join(', ')}`;
          removedQuestionsFormatted.push(removedQuestionInCurrentModule);
        }
      });
  
      if (removedQuestionsFormatted.length) {
        removedQuestionsMap[panelKey] = removedQuestionsFormatted;
      }
    });
  }
  

  /**
   * 
   * @param frmwrkQ question that you want to check whether or not they are a part of the available item banks
   * @returns all questions that were removed in an array of strings formatted: label (id)
   */
  getRemovedQuestions = (frmwrkQ: SimplifiedQuestion) => {
    const removedQuestions = [];
    frmwrkQ.forEach(fq => {
      const isInBankQ = this.itemBankCtrl.questions.some(bq => bq.id === fq.id);
      if (!isInBankQ) {
        removedQuestions.push(fq);
      }
    });
    return removedQuestions.map(q => `${q.label} (${q.id})`);
  }

  alertRemovedQuestions(removedQuestions: RemovedQuestionMap){
    if (Object.keys(removedQuestions).length) {
      Object.entries(removedQuestions)
        .map(([location, questions]) => `\n\t ${location}:${questions.join(', ')}`)
        .join();
      alert( this.lang.tra('framework_remove_missing_item_prompt'));
    }
  }

  removeSectionFromTestForm = (partition: IAssessmentPartition) => {

    const partitionId = partition.id
    const msg = `${this.lang.tra('ie_remove_section')} ${partitionId} ?`;
    if(confirm(msg)) {
      // remove from framework.partitions
      const i = this.asmtFmrk.partitions.indexOf(partition);
      if (i !== -1) {
        this.asmtFmrk.partitions.splice(i, 1);
        // remove from framework.sections
        delete this.asmtFmrk.sectionItems[partitionId];
      }

    }
  }
  
  editRawFramework(){
    this.isEditRawFramework = true;
    this.rawFrameworkJson.setValue(JSON.stringify(this.asmtFmrk, null, 2));
  }
  cancelEditRawFramework(){
    this.isEditRawFramework = false;
  }
  saveRawFramework(){
    const json = JSON.parse(this.rawFrameworkJson.value);
    this.asmtFmrk = json;
    alert('Save and refresh for best results')
    this.isEditRawFramework = false;
  }
  
  openFrameworkParamExport(){
    if (this.isFrameworkParamImportExport){
      this.isFrameworkParamImportExport = false;
    }
    else{
      const data = JSON.stringify(this.activeAsmtFwrkDimensions);
      this.frameworkParamImportExport.setValue(data);
      this.isFrameworkParamImportExport = true;
    }
  }
  
  importFrameworkParams(isInsertOnly:boolean=false){
    const dataJson = this.frameworkParamImportExport.value;
    const newData = JSON.parse(dataJson)
    console.log('isInsertOnly', isInsertOnly)
    if (isInsertOnly){
      const existingFields = new Map();
      const paramLists = [
        this.asmtFmrk.primaryDimensions,
        this.asmtFmrk.secondaryDimensions,
      ]
      paramLists.forEach(paramList =>{
        paramList.forEach(param => {
          existingFields.set(param.code, true)
        })
      })
      for (let list_i=0; list_i<newData.length; list_i++){
        const srcList = newData[list_i];
        const targetList = paramLists[list_i];
        srcList.forEach(param => {
          if (!existingFields.has(param.code)){
            targetList.push(param)
          }
        })
      }
    }
    else{
      this.activeAsmtFwrkDimensions = newData;
      this.asmtFmrk.primaryDimensions = newData[0];
      this.asmtFmrk.secondaryDimensions = newData[1];
    }
    this.isFrameworkParamImportExport = false;
    // this.saveLoadCtrl.saveChanges();
  }
  
  
  addRefDoc(){
    if (!this.asmtFmrk.referenceDocumentPages){
      this.asmtFmrk.referenceDocumentPages = [];
    }
    const itemId = +prompt('Item ID')
    const caption = prompt('Resource Name')
    this.asmtFmrk.referenceDocumentPages.push({itemId, caption})
  }
  
  getTloftFormQuestions(questionSrcDb) {
    const questions = [];
    questionSrcDb.forEach(question => {
      // remove info slides (returning placeholders right now, may need to remove this line in future)
      if (question.isInfoSlide !== undefined) return;

      let questionInfo;
      if (question.label && !question.id) {
        questionInfo = this.itemBankCtrl.getQuestionByLabel(question.label);
      }
      if (!questionInfo) {
        questionInfo = this.itemBankCtrl.getQuestionById(question.id);
      }
      if (questionInfo) {
        console.log(questionInfo.id, questionInfo.label)
        questions.push(questionInfo);  
      }
    });

    return questions;
  }

  getMsCatFormQuestions(panel: IPanelModulesConfig) {
    const questions = []; 
    this.asmtFmrk.panels.forEach(panelConfig => {
      if (panelConfig.id === panel.id) {
        panelConfig.modules.forEach(module => {          
          this.itemBankCtrl.getItems().forEach(question => {
            if (module.itemLabels.indexOf(question.label) !== -1) {
              questions.push(question);
            }
          });
        })
      }
    });
    
    return questions;
  }

  /**
   * Items in the given audit scope — same rules the audit tooling applies.
   * Resolved against the base (EN) item objects so callers can write to them.
   */
  getFormScopedQuestions(scope: AuditQuestionScope = DEFAULT_AUDIT_SCOPE): IQuestionConfig[] {
    if (!this.itemBankCtrl) {
      return [];
    }
    const ctx = buildItemScopeContext(this, this.itemBankCtrl);
    return getQuestionsByScopeSync(scope, ctx, false).filter((question) => !!question);
  }

  getLinearFormQuestions(){
    const questions = [];
    this.asmtFmrk.partitions.forEach(partition => {
      const questionInfoContainer = this.getSectionQuestionsLinear(this.asmtFmrk, partition);
      
      questionInfoContainer.questions.forEach(questionInfo => {
        let question;
        if (questionInfo.label && !questionInfo.id){
          question = this.itemBankCtrl.getQuestionByLabel(questionInfo.label);
          if (question){
            questionInfo.id = question.id;
          }
        }
        if (!question){
          question = this.itemBankCtrl.getQuestionById(questionInfo.id);
        }
        if (question) {
          questions.push(question);  
        }
      });
      // load simplied list of questions
    });
    return questions;
  }

  /**
   * 
   * @param qIds the question IDs to find
   * @returns an array of references to questions determined by their IDs
   */
  getQuestionsById(qIds: number[]){
    const questions: IQuestionConfig[] = [];
    qIds.forEach((id) => {
      let question;
      question = this.itemBankCtrl.getQuestionById(id);
      if (question) {
        questions.push(question);  
      }
    })
    return questions;
  }
  
  getNumQuestions() {
    return this.itemBankCtrl.getItems().length;
  }
  
  getNumQuadrants() {
    if (this.asmtFmrk && this.asmtFmrk.quadrantItems) {
      return this.asmtFmrk.quadrantItems.length;
    }
    return '--';
  }
  getNumTestlets() {
    if (this.asmtFmrk && this.asmtFmrk.testlets) {
      return this.asmtFmrk.testlets.length;
    }
    return '--';
  }
  getNumStoredPanels() {
    if (this.asmtFmrk && this.asmtFmrk.assembledPanels) {
      return this.asmtFmrk.assembledPanels.length;
    }
    return '--';
  }
  getNumTestForms() {
    if (this.asmtFmrk && this.asmtFmrk.testForms) {
      return this.asmtFmrk.testForms.length;
    }
    return '--';
  }
  
  createNewSection(callBack?: (sectionId: number) => void) {
    const description = prompt('new section name', 'New Section');
    if(description === null){return;}
    const id = this.util.nextId(this.asmtFmrk.partitions);
    delete this.asmtFmrk.sectionItems?.[id];
    this.asmtFmrk.partitions.push({
      id,
      description
    });
    this.refreshPartitionToPreambleFcMap();
    callBack?.(id);
  }
  
  selectQuestionView(id: QuestionView) {
    this.selectedQuestionView = id;
    this.panelCtrl.activePanel = null;
    this.panelCtrl.filterToUsed = false;
    this.quadrantCtrl.activeQuadrant = null;
    this.testletCtrl.activeTestlet = null;
    this.itemFilterCtrl.updateItemFilter();
    if (id === QuestionView.TESTLETS) {
      this.testletCtrl.updateTestletFilter();
    }
    if (id !== QuestionView.QUESTION_BANK) {
      this.itemBankCtrl.currentQuestion = null;
    }
  }
  
  parseStats(stats: any) {
    let arr = [];
    Object.keys(stats).forEach(key => {
      arr.push({key, val: stats[key]});
    });
    return arr;
  }
  
  
  newItemBankAdd() {
    const newItemBankId = +this.selectedNewItemBank.value;
    let newItemBank;
    this.availableItemSets.forEach(itemBank => {
      if (itemBank.id === newItemBankId) {
        newItemBank = itemBank;
      }
    });
    // console.log('newItemBank', newItemBankId, newItemBank)
    if (newItemBank) {
      this.saveLoadCtrl.itemBanksUsed.push(newItemBank);
      this.saveLoadCtrl.saveChanges(); // to do: dedicated api call
      this.requireItemBankRefresh = true;
      this.saveLoadCtrl.fakeItemSetSaveBuffer();
    }
    this.isReadyToAddItemSet = false;
  }
  
  removeItemBank(i) {
    this.saveLoadCtrl.itemBanksUsed.splice(i, 1);
    this.saveLoadCtrl.saveChanges(); // to do: dedicated api call
    this.requireItemBankRefresh = true;
    this.saveLoadCtrl.fakeItemSetSaveBuffer();
  }

  newItemBankStart() {
    if ( this.isReadyToAddItemSet) {
      this.isReadyToAddItemSet = false;
    } 
    else if (this.availableItemSets) {
      this.isReadyToAddItemSet = true;
    } 
    else {
      this.isReadyToAddItemSet = true;
      this.myItems
        .loadMyItemSets()
        .then(itemSets => {
          this.saveLoadCtrl.isLoadingItemSets =  false;
          this.availableItemSets = itemSets;
        });
    }
  }

  scrollToQuestionListing() {
    setTimeout(() => {
      // const el = this.questionListingEl.nativeElement;
      // const options = {behavior: 'smooth', block: 'start'};
      // try {
      //   el.scrollIntoView(options);
      // } catch (e) {
      //   el.scrollIntoViewIfNeeded(options);
      // }
    }, 100);
  }
  
  getCurrentParameters (): IAssessmentFrameworkDimensionDetail[] {
    if (this.asmtFmrk) {
      return []
      .concat(this.asmtFmrk.standardParameters ?? [])
      .concat(this.asmtFmrk.primaryDimensions)
      .concat(this.asmtFmrk.secondaryDimensions);
    }
    return [];
  }

  /**
   * All codes that the framework is using for params
   */
  get CurrentParameterCodes (): string[] {
    return this.getCurrentParameters().filter(param => !!param.code).map(param => param.code)
  }
  
  identifySpecialParams(key: string) {
    const params = this.getCurrentParameters();
    const matchingParams: IAssessmentFrameworkDimensionDetail[] = [];
    params.forEach(param => {
      if (param.config && param.config.special) {
        if (param.config.special[key]) {
          matchingParams.push(param);
        }
      }
    });
    return matchingParams;
  }
  
  identifySingleEntryParams() {
    return this.identifySpecialParams(PARAM_SPECIAL_FLAGS.SINGLE_RESPONSE_ENTRY);
  }
  
  identifyBooleanParams() {
    const paramRef: Map<string, boolean> = new Map();
    const params = this.getCurrentParameters();
    params.forEach(param => {
      if (param.type === 'binary') {
        paramRef.set(param.code, true);
      }
    });
    return paramRef;
  }
  
  parseParamColor(color: string) {
    if (color) {
      return color;
    }
    return 'inherit';
  }
  
  openImport() {
    this.isImportOpen = true;
    this.paramImportRunId++;
    this.paramImportPlan = null;
    this.jsonImport.reset();
  }
  closeImport() {
    this.jsonImport.reset();
    this.paramImportRunId++;
    this.paramImportPlan = null;
    this.importProgress = null;
    this.isImportOpen = false;
  }
  get paramImportChangedCount(): number {
    return this.paramImportPlan ? countChangedParamImportCells(this.paramImportPlan) : 0;
  }
  get paramImportUnchangedCount(): number {
    return this.paramImportPlan ? countUnchangedParamImportCells(this.paramImportPlan) : 0;
  }
  get paramImportVisibleCells(): IParamImportCell[] {
    if (!this.paramImportPlan) { return []; }
    return getVisibleParamImportCells(this.paramImportPlan, !!this.isParamImportChangedOnly.value)
      .slice(0, PARAM_IMPORT_MAX_RENDERED_ROWS);
  }
  get paramImportVisibleTotal(): number {
    if (!this.paramImportPlan) { return 0; }
    return getVisibleParamImportCells(this.paramImportPlan, !!this.isParamImportChangedOnly.value).length;
  }
  downloadParamImportPlan() {
    if (!this.paramImportPlan) { return; }
    const csv = buildParamImportChangeSetCsv(this.paramImportPlan);
    const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'param-upload-change-set.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
  /** Re-runs the import from the same file with dry run switched off. */
  applyParamImportPlan() {
    if (this.isImporting || !this.importTarget) { return; }
    this.paramImportPlan = null;
    this.isParamImportDryRun.setValue(false);
    return this.startImport();
  }
  importTarget: FileList
  updateImportTarget(importTarget) {
    this.importTarget = importTarget;
    this.paramImportRunId++;
    this.paramImportPlan = null;
  }
  async startImport() {
    let rows;
    let i = 0;
    const allowNew = this.allowNewItemsDuringParamImport.value
    const isParamImportDryRun = this.isParamImportDryRun.value
    const dimensions = [this.asmtFmrk.standardParameters || [], this.asmtFmrk.primaryDimensions || [], this.asmtFmrk.secondaryDimensions || []];
    const PRIMARY_KEY = 'question_label';
    const CONTENT_KEY = 'content';
    const LANG_KEY = 'lang';
    const ISSUES_KEY = 'issues';
    const NOTES_KEY = 'notes';
    const ITEM_VERSION_KEY = 'item_version_code';
    const reservedKeys = [PRIMARY_KEY,CONTENT_KEY, LANG_KEY, ISSUES_KEY, NOTES_KEY, ITEM_VERSION_KEY];
    try {
      const file = this.importTarget.item(0);
      const fileTypeFull = file.type;
      const fileType = fileTypeFull.split('/')[0];
      const fileExt = file.name.split('.').pop();
      if (fileExt !== 'xlsx') {  
        alert(this.lang.tra('sa_unsupported_file',undefined,{file_type:fileExt})+'. Need XLSX for upload.');
        return 
      }
      const res:any = await this.auth.excelToJson(file);
      rows = res.json;
      console.log(rows)
      // rows = JSON.parse(this.jsonImport.value);
      
    } catch (e) {
      alert('invalid JSON input');
      return;
    }
    // identify parameters
    const paramRef: Map<string, IAssessmentFrameworkDimensionDetail> = new Map();
    dimensions.forEach(dim => {
      dim.forEach(param => {
        paramRef.set(param.code, param);
      });
    });
    // identify changes
    type ParamVal = boolean | string | number;
    const changedQuestionProp:{question_label:string, param:string, val_old:ParamVal, val_new:ParamVal }[] = [];
    const planCells: IParamImportCell[] = [];
    const newItemLabels: string[] = [];
    this.paramImportPlan = null;
    const unknownParameters:{[key:string]:boolean} = {};
    // sanitize labels (trim so spreadsheet padding does not look like missing items)
    rows.forEach(questionRow => {
      questionRow.question_label = normalizeQuestionImportLabel(questionRow.question_label);
    });
    // identify questions
    const questionsByLabel = buildQuestionsByImportLabel(this.itemBankCtrl.getItems());
    const missingQuestions = [];
    if (!allowNew){
      rows.forEach(questionRow => {
        const label = questionRow.question_label;
        if (!questionsByLabel.has(label)){
          missingQuestions.push(label);
        }
      });
      if (missingQuestions.length > 0){
        console.log('new items', missingQuestions);
        alert( missingQuestions.length + ' new question labels detected. Please select the checkbox to allow new items to be created with the import, or remove the new item labels from your import (see the log for a full list of the question_labels at issue).');
        return;
      }
    }
    const compareRow = (row:any, question:any, cells: IParamImportCell[]): {[key:string]:number | string | boolean} => {
      const questionLabel = row[PRIMARY_KEY];
        const rowValues:{[key:string]:number | string | boolean} = {};
        Object.keys(row).forEach(paramCode => {
          let val = row[paramCode];
          if ( reservedKeys.indexOf(paramCode) === -1) {
            const param = paramRef.get(paramCode);
            if (!param) { unknownParameters[paramCode] = true }
            else {
              if (param.type === DimensionType.BINARY){
                switch (val){
                  case 'TRUE':
                  case 'true':
                  case '1':
                  case 1:
                    val = true;
                    break;
                  case 'false':
                  case 'FALSE':
                  case 0:
                  default:
                    val = false;
                    break;
                }
              }
              if (param.type === DimensionType.NUMERIC){
                if (val || val === 0){
                  val = ''+val;
                }
              }
              if (param.type === DimensionType.COORD && val){
                if(typeof val === 'string'){
                  try {
                    val = JSON.parse(val)
                  } catch {
                    console.error(`Could not parse ${paramCode} for question ${questionLabel}`)
                    return;
                  }
                } 
                if (
                  typeof val !== 'object' || 
                  !('x' in (val ?? {})) || 
                  !('y' in (val ?? {}))
                ) {
                  console.error(`Could not parse ${paramCode} for question ${questionLabel}`);
                  return;
                }
              }
              if (param.type === DimensionType.VOICE || param.type === DimensionType.IMAGE){
                const allowedAudioExts = ['mp3'];
                const allowedImageExts = ['jpeg', 'jpg', 'png', 'svg'];

                const isAudio = param.type === DimensionType.VOICE;
                if (typeof val === 'string') {
                  const trimmedVal = val.trim();

                  if (trimmedVal.startsWith('{')) {
                    try {
                      val = JSON.parse(trimmedVal);
                    } catch {
                      console.error(`Could not parse ${paramCode} for question ${questionLabel}`);
                      return;
                    }
                  } else if (trimmedVal.length > 0 && trimmedVal.startsWith('http')) {
                    const cleanUrl = trimmedVal.split('?')[0].split('#')[0];
                    const extension = cleanUrl.split('.').pop()?.toLowerCase() || '';

                    const validExtensions = isAudio ? allowedAudioExts : allowedImageExts;

                    if (!validExtensions.includes(extension)) {
                      console.error(
                        `Invalid file type extension '.${extension}' for ${paramCode} in question ${questionLabel}. Expected: ${validExtensions.join(', ')}`
                      );
                      return;
                    }

                    const mimeType = isAudio
                      ? `audio/${extension === 'mp3' ? 'mpeg' : extension}`
                      : `image/${extension === 'jpg' ? 'jpeg' : extension}`;
                    val = {
                      url: trimmedVal,
                      urls: [trimmedVal],
                      scale: 100,
                      altText: "",
                      fileType: mimeType,
                      hiContrastImg: { elementType: "image", url: null, scale: 100, scaleFactor: 20 }
                    };
                  } else {
                    console.error(`Invalid ${isAudio ? 'audio' : 'voice'} format (${val}) for '${paramCode}' in question '${questionLabel}'.`);
                    return
                  }
                }
              }
              const val_old = question.meta[paramCode];
              const val_new = val;
              const isBothFalsey = ( (!val_old && val_old!==0) && (!val_new && val_new!==0) ) // except zeroes, those are important to handle NaN errors
              const isObject = (val: any): boolean => typeof val === 'object' && val !== null;
              // If it's an object we need to compare differently than primitive types
              const isSame = (isObject(val_old) || isObject(val_new))
                ? JSON.stringify(val_old) === JSON.stringify(val_new)
                : ('' + val_old === '' + val_new);
              cells.push({
                question_label: questionLabel,
                param: paramCode,
                val_old,
                val_new,
                changed: !isSame && !isBothFalsey,
                is_new_item: !!(<any>question).__isDryRunNewItem,
              });
              if (!isSame && !isBothFalsey){ // intentionally less strict due to high number of undefined etc. being picked up
                changedQuestionProp.push({
                  question_label: questionLabel, 
                  param: paramCode, 
                  val_old, 
                  val_new,
                })
                rowValues[paramCode] = val;
              }
            }
          } else {
          if (paramCode === ITEM_VERSION_KEY && row[paramCode] !== undefined) {
            cells.push({
              question_label: questionLabel,
              param: ITEM_VERSION_KEY,
              val_old: question?.item_version_code,
              val_new: row[ITEM_VERSION_KEY],
              changed: isParamImportValueChange(question?.item_version_code, row[ITEM_VERSION_KEY]),
              is_new_item: !!(<any>question).__isDryRunNewItem,
            });
            if (question?.id) {
              const validItemVersionCodes = this.itemBankCtrl?.getItemVersionCodeOptionsForQuestion(question) ?? [];
              if (!validItemVersionCodes.includes(row[ITEM_VERSION_KEY]) && row[ITEM_VERSION_KEY]) {
                console.warn("INVALID_VERSION_CODE", { id: question.id, item_version_code: row[ITEM_VERSION_KEY], validItemVersionCodes })
              }
              rowValues.item_version_code = row[ITEM_VERSION_KEY];
            }
          }
          }
        })
      return rowValues;
    };
    // DRY RUN: sweep the values already loaded in the item bank first (no per-row API calls,
    // no item selection) so the delta appears immediately, then re-check only the items that
    // show a change against the server in the background.
    if (isParamImportDryRun) {
      const runId = ++this.paramImportRunId;
      const rowCells: IParamImportCell[][] = rows.map(() => []);
      const rowQuestions: any[] = [];
      rows.forEach((row, idx) => {
        const label = row[PRIMARY_KEY];
        let question = questionsByLabel.get(label);
        if (!question) {
          if (!newItemLabels.includes(label)) { newItemLabels.push(label); }
          question = <any>{ label, meta: {}, __isDryRunNewItem: true };
        }
        rowQuestions[idx] = question;
        compareRow(row, question, rowCells[idx]);
      });
      const flatten = (): IParamImportCell[] => rowCells.reduce((all, cells) => { cells.forEach(c => all.push(c)); return all; }, <IParamImportCell[]>[]);
      const plan: IParamImportPlan = {
        cells: flatten(),
        unknownParameters: Object.keys(unknownParameters),
        newItemLabels,
        rowsProcessed: rows.length,
      };
      this.paramImportPlan = plan;
      this.importingQuestionLabel = null;

      const toVerify = rows.map((_, idx) => idx).filter(idx => rowQuestions[idx].id && rowCells[idx].some(c => c.changed));
      plan.verify = { total: toVerify.length, done: 0, corrected: 0, status: toVerify.length ? 'running' : 'done' };
      if (toVerify.length) {
        const queue = toVerify.slice();
        let failures = 0;
        const worker = async () => {
          while (queue.length && runId === this.paramImportRunId) {
            const idx = queue.shift();
            try {
              const record: any = await this.auth.apiGet(this.itemBankCtrl.routes.TEST_AUTH_QUESTIONS, rowQuestions[idx].id);
              const config = JSON.parse(record.config);
              const fresh = { ...rowQuestions[idx], meta: config.meta || {}, item_version_code: record.item_version_code };
              const next: IParamImportCell[] = [];
              compareRow(rows[idx], fresh, next);
              plan.verify.corrected += countChangedFlips(rowCells[idx], next);
              rowCells[idx] = next;
            } catch (e) {
              failures++;
              console.error('Dry run verification failed for', rows[idx][PRIMARY_KEY], e);
            }
            plan.verify.done++;
            if (plan.verify.done % 25 === 0 && runId === this.paramImportRunId) { plan.cells = flatten(); }
          }
        };
        Promise.all(Array.from({ length: 5 }, worker)).then(() => {
          if (runId !== this.paramImportRunId) { return; }
          plan.cells = flatten();
          plan.verify.status = failures ? 'error' : 'done';
        });
      }
      return;
    }
    // apply modifications
    this.isImporting = true;
    this.importProgress = { done: 0, total: rows.length };
    const increment = () => {
      i ++;
      if (this.importProgress) { this.importProgress.done = Math.min(i, rows.length); }
      if (i < rows.length) {
        applyNextQuestion();
      } 
      else {
        this.isImporting = false;
        this.isImportFlushing = true;
        this.importProgress = null;
        console.log('Unknown Parameters', Object.keys(unknownParameters))
        console.log('Changed Question Props', changedQuestionProp)
        setTimeout(() => {
          this.isImportFlushing = false;
        }, 500);
        this.itemFilterCtrl.updateItemFilter();
        this.saveLoadCtrl.saveContent();
        this.closeImport();
      }
    };
    const selectQuestionByLabel = (questionLabel:string): PromiseLike<any> => {
      this.importingQuestionLabel = questionLabel;
      const question = questionsByLabel.get(questionLabel);
      if (!question) {
        if (allowNew){
          console.warn('Creating a new item', questionLabel);
          return this.itemBankCtrl.createNewQuestion(ItemType.ITEM).then(question=>{
            question.label = questionLabel;
            return question;
          })
        }
        else{
          increment();
        }
      }
      else{
        return this.itemBankCtrl.selectQuestion(question).then(res => question);
      }
    }
    const applyNextQuestion = () => {
      const row = rows[i];
      const questionLabel = row[PRIMARY_KEY];
      return selectQuestionByLabel(questionLabel)
      .then((question:IQuestionConfig) => {
        // identify changes
        const rowValues = compareRow(row, question, planCells);
        if (!isParamImportDryRun){
          // apply changes
          Object.keys(rowValues).forEach(paramCode => {
            const val = rowValues[paramCode];
            const param = paramRef.get(paramCode);
            if (param) {
              if (param.type === DimensionType.SELECT){
                let isMatchFound = false;
                if (!param.config.tags){ param.config.tags = []; }
                param.config.tags.forEach(tag => {
                  if (tag.code === val){
                    isMatchFound = true;
                  }
                })
                if (!isMatchFound){
                  param.config.tags.push({code:<string>val, name:''})
                }
              }
            }
            else{
              if(paramCode === ITEM_VERSION_KEY && row[paramCode] !== undefined){
                question[paramCode] = row[paramCode];
              } else {
                console.warn(paramCode, ' meta data is not defined in framework');
              }
            }
            question.meta[paramCode] = val;
          });
          if (row[CONTENT_KEY]){
            if (row[LANG_KEY] === 'fr'){
              question.langLink.content = row[CONTENT_KEY];
            }
            else{
              question.content = row[CONTENT_KEY];
            }
          }
          if (row[NOTES_KEY]){
            question.notes = (question.notes || '') + '\n\n' + row[NOTES_KEY]
          }
        }
        
        if (isParamImportDryRun){
          increment();
        }
        else{
          this.itemBankCtrl.selectQuestion(question).then(()=>{ // this forces a save
            // console.log('ISSUES_KEY', row[ISSUES_KEY])
            if (row[ISSUES_KEY]){
              row[ISSUES_KEY].map(issueCaption => {
                this.createIssue(question.id, issueCaption);
              })
            }
            increment();
          })
        }
        // console.log(question.label, 'updated question')
      });
    };
    console.log('rows', rows);
    applyNextQuestion();
  }
  
  sanitizeParameterValue = (paramCode, val, paramRef, isExport=false) => {
    const param = paramRef.get(paramCode);
    if (param){
      switch(param.type){
        case DimensionType.BINARY:  return !!val;
        case DimensionType.SELECT:  return val || ''  ; 
        case DimensionType.NUMERIC:
          const isNan = ['', true, false].includes(val) || Number.isNaN(+val);
          const exportVal = isNan? '': +val; 
          const nonExportVal = +(val || 0);
          return isExport ? exportVal : nonExportVal; // reverted so only on export logic will change
        case DimensionType.LABEL:   return val || ''  ; 
        case DimensionType.TEXT:    return val ? val.caption : '' ; 
      }
    }
    return val ? JSON.stringify(val) : ''
  }

  getVal = (param: IAssessmentFrameworkDimensionDetail, question:IQuestionConfig, scoringInfo: IQuestionScoringInfo, paramRef: Map<string, IAssessmentFrameworkDimensionDetail>, isExport:boolean = false ) => {
    switch(param.category){
      case DimensionCategory.SCORING:
        return this.sanitizeParameterValue(param.code, scoringInfo[param.code], paramRef, isExport)
      case DimensionCategory.META:
      default:
        return this.sanitizeParameterValue(param.code, question.meta[param.code], paramRef, isExport);
    }
  }
  
  generateRows(questions, excludeHidden = null, parseEmptyNumericToString = false, includePsychStats = false, includeSimplifiedExtraction = false) {
    const dimensions = [this.asmtFmrk.standardParameters || [], this.asmtFmrk.primaryDimensions, this.asmtFmrk.secondaryDimensions];
    const paramRef: Map<string, IAssessmentFrameworkDimensionDetail> = new Map();
    const params = this.getCurrentParameters();
    params.forEach(param => {
      paramRef.set(param.code, param);
    });

    const rows = []
    questions.forEach(question => {
      const row = {
        item_id: question.id, 
        question_label: question.label,
        quadrantFreq: question.quadrantFreq,
        estimatedExposure: question.estimatedExposure,
        item_version_code: question.item_version_code
      };

      this.generateDynamicColumns(row, question);

      dimensions.forEach(dim => {
        dim.forEach(param => {
          if (excludeHidden === false) {
            row[param.code] = this.getVal(param, question, this.itemBankCtrl.getQuestionScoringInfo(question.id), paramRef, parseEmptyNumericToString );
          } else {
            if (!param.isHidden) {
              row[param.code] = this.getVal(param, question, this.itemBankCtrl.getQuestionScoringInfo(question.id), paramRef, parseEmptyNumericToString );
            }
          }
        });
      });
      if(includePsychStats){
        this.generatePsychStatCols(row, question);
      }
      if(includeSimplifiedExtraction){
        this.generateSimplifiedExtractionCols(row, question);
      }
      rows.push(row);
    });
    return rows;
  }

  generateDynamicColumns(row: any, question: any) {
    if(!question || !question.id) return;
    
    const cols = ['stage', 'assignees', 'assigned_editors', 'pending_graphic_requests', 'assigned_resource', 'is_resource', 'is_questionnaire', 'expected_answer', 'weight']
    cols.forEach((val) => row[val] = null);

    // Workflow (commenting out because these columns are not found on qc8)
    // row['stage'] = this.itemBankCtrl.renderQuestionStageFull(question.id) || null
    // if(this.itemBankCtrl.getQuestionStage(question.id)?.isEditStage) {
    //   row['stage'] + ' ' + this.itemBankCtrl.getNumTimesEnterEdit(question.id);
    // }
    // row['assignees'] = this.itemBankCtrl.renderQuestionStageAssignees(question.id) || null;
    // row['assigned_editors'] = this.itemBankCtrl.renderQuestionEditorAssignees(question.id) || null;
    row['pending_graphic_requests'] = this.itemBankCtrl.getNumPendingGraphicReqs(question.id) || null;
    
    // Expected Answer
    if(this.itemBankCtrl.hasExpectedAnswer(question.id)) {
      row['expected_answer'] =  this.itemBankCtrl.getEAOptions(question.id).join(', ');
      row['weight'] = this.itemBankCtrl.getEAWeight(question.id);
    }
    
    // Reading selections
    const readSels: string[] = this.itemBankCtrl.getReadingSelections(this.itemBankCtrl.getQuestionContent(question));
    if(readSels && readSels.length) {
      row['assigned_resource'] = readSels.join(', ');
    }

    row['is_resource'] = question.isReadingSelectionPage ?? false;
    row['is_questionnaire'] = question.isQuestionnaire ?? false;
    row['is_attestation'] = question.isAttestation ?? false;
  }

  generatePsychStatCols(row:any, question:any){
        // Export Psych Stats
    if(this.itemBankCtrl.psychStatsProps?.length){
      const records = this.itemBankCtrl.getQuestionStats(question);
      this.itemBankCtrl.psychStatsProps.forEach(prop =>{
        if(records?.length){
          let val = records.map(record => record[prop])?.filter(val => val === 0 || !!val)?.join(', ')
          row['PSYCH_' + prop] = val
        } else {
          row['PSYCH_' + prop] = null
        }
      })
    }
  }

  private generateSimplifiedExtractionCols(row: any, question: any) {
    const content: any[] = question?.content;
    if (!content?.length) return;

    const allElements = this.collectDeepElements(content);

    const stimulusParts: string[] = [];
    allElements.forEach(el => {
      const t = el.elementType || el.type;
      if (t === 'mcq' || t === 'custom_mcq') return;
      const text = this.extractElementText(el);
      if (text) stimulusParts.push(text);
    });
    row['stimulus'] = stimulusParts.join(' ') || null;

    const mcqEl = allElements.find(el => {
      const t = el.elementType || el.type;
      return t === 'mcq' || t === 'custom_mcq';
    });
    const optionKeys = ['option_a', 'option_b', 'option_c', 'option_d'];
    optionKeys.forEach((key, i) => {
      const opt = mcqEl?.options?.[i];
      row[key] = opt ? (opt.content || opt.caption || opt.label || null) : null;
    });
  }

  private collectDeepElements(content: any[]): any[] {
    const elements: any[] = [];
    const collect = (arr: any[]) => {
      if (!arr?.length) return;
      arr.forEach(el => {
        if (!el) return;
        elements.push(el);
        if (Array.isArray(el.content)) collect(el.content);
        if (Array.isArray(el.advancedList)) collect(el.advancedList);
        if (Array.isArray(el.options)) { /* skip — handled at MCQ level */ }
      });
    };
    collect(content);
    return elements;
  }

  private extractElementText(el: any): string | null {
    const t = el.elementType || el.type;
    switch (t) {
      case 'text':
      case 'text_link': {
        if (el.paragraphList?.length) {
          return el.paragraphList.map(p => p.caption || '').filter(Boolean).join(' ');
        }
        if (el.simpleList?.length) {
          return el.simpleList.filter(Boolean).join(' ');
        }
        return el.caption || null;
      }
      case 'math':
        return el.latex || null;
      case 'passage':
        return [el.header, el.text, el.footer].filter(Boolean).join(' ') || null;
      default:
        return null;
    }
  }
  
  async exportItemRegister() {
    const registerMap = this.itemBankCtrl.historicalItemRegister;
    if (!registerMap?.size) return;

    const labelById: Map<number, string> = new Map();
    (this.itemBankCtrl.questions || []).forEach(q => labelById.set(+q.id, q.label));

    const twTitleById: Map<number, string> = new Map();
    const summary = this.itemBankCtrl.itemRegisterSummary;
    if (summary?.test_windows?.length) {
      summary.test_windows.forEach(tw => twTitleById.set(tw.id, tw.title));
    }

    const rows: any[] = [];
    registerMap.forEach((twMap, questionId) => {
      twMap.forEach((records, twId) => {
        records.forEach(record => {
          const { test_window_id, test_design_id, ...params } = record;
          rows.push({
            item_id: questionId,
            question_label: labelById.get(questionId) || '',
            test_window_id,
            test_window_title: twTitleById.get(twId) || '',
            test_design_id,
            ...params,
          });
        });
      });
    });

    const filename = `item-register-${this.itemBankCtrl.currentSetName.value}-${moment().format('YYYY-MM-DD[T]HH_mm_ss')}`;
    const res = <any> await this.auth.jsonToExcel(rows, filename);
    downloadFile(res.url);
  }

  exportFrameworkJson() {
    if (!this.asmtFmrk) return;
    const filename = `framework-${this.itemBankCtrl.currentSetName.value}-${moment().format('YYYY-MM-DD[T]HH_mm_ss')}.json`;
    downloadStr(JSON.stringify(this.asmtFmrk, null, 2), filename);
  }

  exportItemBankJson(itemBank: { id: number, slug: string, name: string }) {
    const questions = (this.itemBankCtrl.questions || []).filter(q => +q.question_set_id === +itemBank.id);
    const payload = questions.map(q => ({
      id: q.id,
      label: q.label,
      item_version_code: q.item_version_code,
      question_set_id: q.question_set_id,
      type: q.type,
      meta: q.meta,
      content: q.content,
      entryOrder: q.entryOrder,
      isReady: q.isReady,
      isLocked: q.isLocked,
      langLink: q.langLink ? {
        id: q.langLink.id,
        label: q.langLink.label,
        content: q.langLink.content,
        entryOrder: q.langLink.entryOrder,
        meta: q.langLink.meta,
      } : undefined,
    }));
    const filename = `${itemBank.id}-${itemBank.slug}.json`;
    downloadStr(JSON.stringify(payload, null, 2), filename);
  }

  async exportMsCatTable(panel) {
    const rows = this.generateRows(this.getMsCatFormQuestions(panel));
    const filename = `qb-${this.itemBankCtrl.currentSetName.value}-${moment().format('YYYY-MM-DD[T]HH_mm_ss')}`;
    const res = <any> await this.auth.jsonToExcel(rows, filename)
    downloadFile(res.url);
  }

  async exportTable(excludeHidden: boolean, includePsychStats: boolean = false, includeSimplifiedExtraction: boolean = false) {
    const rows = this.generateRows(this.itemFilterCtrl.filteredQuestions, excludeHidden, true, includePsychStats, includeSimplifiedExtraction);
    const filename = `qb-${this.itemBankCtrl.currentSetName.value}-${moment().format('YYYY-MM-DD[T]HH_mm_ss')}`;
    const res = <any> await this.auth.jsonToExcel(rows, filename)
    downloadFile(res.url);
  }
  
  private createIssue(item_id, text){
    const user = this.auth.user().getValue();
    const data: IItemAuthNote = {
      text,
      parent_note_id: null,
      item_id,
      has_child: 0,
      is_resolved: 0,
      assigned_uid: null,
      created_by_first_name: user.firstName, // get user info from auth in API.
      created_by_last_name: user.lastName,
      created_by_uid: user.uid,
    };
    return this.auth.apiCreate('public/test-auth/notes', data);
  }

  refreshPartitionToPreambleFcMap() {
    for(const partition of this.asmtFmrk.partitions) {
      if(!this.partitionIdToPreambleFc[partition.id]) {
        this.partitionIdToPreambleFc[partition.id] = new FormControl();
      }
      if(!this.partitionIdToPostambleFc[partition.id]) {
        this.partitionIdToPostambleFc[partition.id] = new FormControl();
      }
    }
  }

  hoistAssessmentFrameworkForEditing() {
    // console.log('Assessment Framework: ', asmtFwrk);
    const asmtFwrk = this.asmtFmrk;
    this.refreshPartitionToPreambleFcMap();
    this.asmtFmrk.quadrantIdAI = this.asmtFmrk.quadrantIdAI || 0;
    this.asmtFmrk.parititionIdAI = this.asmtFmrk.parititionIdAI || 0;
    this.asmtFmrk.showDocumentsSplitScreen = this.asmtFmrk.showDocumentsSplitScreen || false;
    this.asmtFmrk.showQHeader = this.asmtFmrk.showQHeader || false;
    this.asmtFmrk.nextButtonOpt = this.asmtFmrk.nextButtonOpt || ENextBtnOpt.NEXT;
    if (!this.asmtFmrk.partitions) {
      this.asmtFmrk.partitions = [];
    }
    if (!this.asmtFmrk.quadrants) {
      this.asmtFmrk.quadrants = [];
    }
    sortQuadrantsBySectionInPlace(this.asmtFmrk.quadrants, this.asmtFmrk.partitions);
    if (!this.asmtFmrk.testlets) {
      this.asmtFmrk.testlets = [];
    }
    this.activeAsmtFwrkDimensions = [
      asmtFwrk.primaryDimensions,
      asmtFwrk.secondaryDimensions,
      asmtFwrk.standardParameters || []

    ];

    this.asmtFmrk.styleProfile = this.itemBankCtrl.styleProfileSelector.value;

    this.publishingCtrl.loadTestDesignReleaseHistory();

    this.questionWordingFc.setValue(this.asmtFmrk.questionWordSlug);

    this.testFormConstructionMethod.setValue(this.asmtFmrk.testFormType || TestFormConstructionMethod.LINEAR);
    if (this.asmtFmrk.testFormType === TestFormConstructionMethod.LINEAR && this.asmtFmrk.partitions) {
      this.itemBankCtrl.selectSection(this.asmtFmrk.partitions[this.asmtFmrk.partitions.length - 1]);
      this.selectQuestionView(QuestionView.FORM_CONSTRUCTION);
    }
    this.quadrantCtrl.refreshQuadrantItems();
  }

  newTag(){
    const slug = prompt('Which tag?')
    if (!this.asmtFmrk.tags){
      this.asmtFmrk.tags = []
    }
    this.asmtFmrk.tags.push({slug})
  }

  newPreservedParam(){
    const slug = prompt('Which parameter?')
    if (!this.asmtFmrk.preservedMetaParams){
      this.asmtFmrk.preservedMetaParams = []
    }
    this.asmtFmrk.preservedMetaParams.push(slug)
  }

  addAuditPreservedParam(param:string){
    if (!this.asmtFmrk.auditedPreservedMetaParams){
      this.asmtFmrk.auditedPreservedMetaParams = []
    }
    this.asmtFmrk.auditedPreservedMetaParams.push(param)
  }

  togglePreservedParam(param: string){
    if (this.isAuditedPreservedParam(param)) {
      this.removeAuditPreservedParam(param);
    } else {
      this.addAuditPreservedParam(param);
    }
  }

  removeAuditPreservedParam(param: string){
    this.asmtFmrk.auditedPreservedMetaParams = this.asmtFmrk.auditedPreservedMetaParams.filter(slug => param !== slug);
  }

  isAuditedPreservedParam(param: string){
    return this.asmtFmrk.auditedPreservedMetaParams && this.asmtFmrk.auditedPreservedMetaParams.findIndex(val => val === param) !== -1;
  }

  defineNewParameter(arr: IAssessmentFrameworkDimensionDetail[]) {
    arr.push({
      name: 'New Parameter', // ex: Number Sense
      code: '', // ex: NS
      type: DimensionType.BINARY,
      config: {

      }
    });
  }

  newSimilaritySlug(){
    const slug = prompt('Which slug?')
    if (!this.asmtFmrk.similaritySlugs){
      this.asmtFmrk.similaritySlugs = []
    }
    this.asmtFmrk.similaritySlugs.push({slug})
  }

  isPsychoParam(param: IAssessmentFrameworkDimensionDetail) {
    return param && param.config && param.config.special && param.config.special[PARAM_SPECIAL_FLAGS.PSYCHO_EDIT];
  }

  getAccSettingConfigVal(settingProp: string, configProp: string) {
    if(!this.asmtFmrk.accessibilitySettings || (typeof this.asmtFmrk.accessibilitySettings !== 'object')) {
      this.asmtFmrk.accessibilitySettings = {};
    }
    if(!this.asmtFmrk.accessibilitySettings[settingProp]) {
      this.asmtFmrk.accessibilitySettings[settingProp] = this.accessibilitySettings[settingProp];
    }
    return this.asmtFmrk.accessibilitySettings[settingProp][configProp];
  }

  getAccSettingConfigurable(settingProp: string) {
    return this.getAccSettingConfigVal(settingProp, 'isConfigurable');
  }

  getAccSettingDefault(settingProp: string) {
    return this.getAccSettingConfigVal(settingProp, 'defaultVal');
  }

  getPartitionPropValue = <K extends keyof IAssessmentPartition>(
    partition: IAssessmentPartition,
    prop: K
  ): IAssessmentPartition[K] => {

    const lang = this.lang.c();
    const useLangSpecificSectionProps = this.asmtFmrk.useLangSpecificSectionProps;
    return getPartitionPropValue(partition, prop, lang, useLangSpecificSectionProps);

  }

  get setOfQuestionsInTestlets() {
    const questionsInTestlet = new Set<number>();
    this.asmtFmrk.testlets.forEach(testlet => {
      if (testlet.isDisabled) { return; } // we don't want to include disabled testlets
      testlet.questions.forEach(question => {
        questionsInTestlet.add(+question.id);
      });
    });
    return questionsInTestlet
  }

  paramRef: Map<string, IAssessmentFrameworkDimensionDetail> = new Map();
  getParamRef(paramCode: string){
    if(!this.paramRef?.has(paramCode)){
      const param = this.getCurrentParameters()?.find(param => param.code === paramCode)
      if(param){
        this.paramRef.set(paramCode, param)
      }
    }
    return this.paramRef.get(paramCode)
  }

  getParamIsIncorrectType(val: any, paramCode: string){
    const param = this.getParamRef(paramCode);
    if(param && val != null && val !== ''){// Only check if param is populated
      const {type} = param;
      switch(type){
        case DimensionType.NUMERIC:
          return checkPropCondVal(val, EFilterMethods.IS_NAN) && typeof val === 'string'
        case DimensionType.SELECT: //TODO implement rest of the req type changes
          const param =  this.getParamRef(paramCode);
          if(param?.config?.tags){
            const options = param.config.tags.map(tag => tag.code);
            return !options.includes(val.toString());
          }
          return true
        case DimensionType.BINARY:
          return ![true, false, 0 , 1, '0', '1'].includes(val);
        case DimensionType.LABEL:
          return typeof val !== 'string' && typeof val !== 'number'
        case DimensionType.TEXT:
          return typeof val !== 'object' || !("caption" in val)
        case DimensionType.IMAGE:
        case DimensionType.AUDIO:
        case DimensionType.COORD:
        case DimensionType.VOICE:
        default:
          return false;
      }
    }
    return false
  }

  /**
   * Adds or updates a validation flag for a specific audit check.
   * If a flag for the same auditId and checkId exists, it is updated.
   */
  addParamFlag(
    questionId: number | string, 
    dimension: string, 
    auditId: string, 
    checkId: string, 
    flagMessage: string
  ): void {
    const qId = +questionId;
    const flagMap = this.paramFlaggedMap;

    // 1. Ensure the Question Map exists
    if (!flagMap.has(qId)) {
      flagMap.set(qId, new Map<string, IParamFlag[]>());
    }
    const questionFlags = flagMap.get(qId)!;

    // 2. Ensure the Dimension Array exists
    if (!questionFlags.has(dimension)) {
      questionFlags.set(dimension, []);
    }
    const currentFlags = questionFlags.get(dimension)!;

    // 3. Remove existing flag for THIS specific audit + check (to avoid duplicates)
    const filteredFlags = currentFlags.filter(f => 
      !(f.auditId === auditId && f.checkId === checkId)
    );

    // 4. Push the new flag and update the Map
    filteredFlags.push({ auditId, checkId, message: flagMessage });
    questionFlags.set(dimension, filteredFlags);
  }


  getParamFlaggedMessages(question:IQuestionConfig, param: string): string{
    if(!this.isParamFlagged(question, param)){
      return ''
    } else {
      const qId = +(question?.id ?? -1);
      const flags = this.paramFlaggedMap.get(qId)?.get(param) ?? [];
      const message = new Set<string>()
      flags.forEach(flag => {
        message.add(this.lang.tra(flag.message))
      })
      return Array.from(message).join('\n')
    }
  }
  
  isParamFlagged(question:IQuestionConfig, param: string){
    return this.paramFlaggedMap.get(+(question.id ?? -1))?.get(param)?.length;
  }

  /** Unique param codes flagged on any item (optionally for one check). This is the column collector. */
  getUniqueFlaggedParamCodes(checkId?: string): string[] {
    const codes = new Set<string>();
    this.paramFlaggedMap.forEach((dimensionMap) => {
      dimensionMap.forEach((flags, code) => {
        if (!checkId || flags.some(flag => flag.checkId === checkId)) {
          codes.add(code);
        }
      });
    });
    return Array.from(codes).sort((a, b) => a.localeCompare(b));
  }

  get flaggedParamCodesCsv(): string {
    return this.getUniqueFlaggedParamCodes().join(', ');
  }

  setParamCodeCollector(checkId: string, codes: string[]): void {
    if (!checkId) {
      return;
    }
    const unique = Array.from(new Set(codes.filter(Boolean))).sort((a, b) => a.localeCompare(b));
    this.paramCodeCollectorByCheckId.set(checkId, unique);
  }

  getCollectedParamCodes(checkId?: string): string[] {
    if (checkId) {
      const collected = this.paramCodeCollectorByCheckId.get(checkId);
      if (collected?.length) {
        return collected;
      }
    }
    return this.getUniqueFlaggedParamCodes(checkId);
  }

  setSessionContentParamCodes(codes: string[] | null): void {
    const next = (codes || [])
      .map(code => (code || '').trim())
      .filter(code => !!code);
    if (!next.length) {
      this.sessionContentParamCodes = null;
      this.sessionContentParamInput = '';
      return;
    }
    this.sessionContentParamCodes = next;
    this.sessionContentParamInput = next.join(', ');
    this.itemFilterCtrl?.activeParameterTypes?.set(ItemParameterType.CONTENT, true);
  }

  applySessionContentParamFilter(raw?: string): void {
    const source = raw !== undefined ? raw : this.sessionContentParamInput;
    this.sessionContentParamInput = source || '';
    this.setSessionContentParamCodes(parseParamCodeList(source));
  }

  clearSessionContentParamFilter(): void {
    this.setSessionContentParamCodes(null);
  }

  isContentParamInSessionScope(code: string): boolean {
    if (!this.sessionContentParamCodes) {
      return true;
    }
    const wanted = new Set(this.sessionContentParamCodes.map(c => c.toLowerCase()));
    return wanted.has((code || '').toLowerCase());
  }

  rebuildParamCodeCollectorsFromFlags(): void {
    this.paramFlaggedMap.forEach((dimensionMap) => {
      dimensionMap.forEach((flags, code) => {
        flags.forEach(flag => {
          if (!flag.checkId) {
            return;
          }
          const existing = this.paramCodeCollectorByCheckId.get(flag.checkId) || [];
          if (!existing.includes(code)) {
            this.paramCodeCollectorByCheckId.set(
              flag.checkId,
              [...existing, code].sort((a, b) => a.localeCompare(b))
            );
          }
        });
      });
    });
  }

  get setOfQuestionsInQuadrants() {
    const questionsInQuadrants = new Set<number>();
    this.asmtFmrk.quadrantItems.forEach(quadrantItemSet => {
      quadrantItemSet.questions.forEach(question => {
        questionsInQuadrants.add(+question.id);
      });
    });
    return questionsInQuadrants
  }

}
